import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_HISTORY = 'GET_HISTORY';

export const actions = createSagaActionTypes('SHOW_HISTORY', [GET_HISTORY]);
